import { useReactiveVar } from '@apollo/client';
import CheckIcon from '@mui/icons-material/Check';
import PaletteIcon from '@mui/icons-material/Palette';
import { ListItemButton, ListItemIcon, ListItemText, ListSubheader, useTheme } from '@mui/material';
import { userThemeVariantVar } from 'client/cache';
import { useExtendedIntl } from 'hooks/useExtendedIntl';
import { FunctionComponent } from 'react';
import { LEADZAI_THEME_VARIANTS, type LeadzaiThemeVariant } from '@v2/theme/whitelabels/leadzai/constants';

interface ThemeVariantMenuProps {
  onSelect: () => void;
}

export const ThemeVariantMenu: FunctionComponent<ThemeVariantMenuProps> = ({ onSelect }) => {
  const theme = useTheme();
  const { formatMessage } = useExtendedIntl();
  const userThemeVariant = useReactiveVar(userThemeVariantVar);

  const handleVariantSelect = (variant: LeadzaiThemeVariant) => {
    userThemeVariantVar(variant);
    onSelect();
  };

  return (
    <>
      <ListSubheader component="div" sx={{ lineHeight: 2.5 }}>
        {formatMessage({ id: 'navigation-menu.theme-variant' })}
      </ListSubheader>
      {LEADZAI_THEME_VARIANTS.map((variant) => {
        const selected = userThemeVariant === variant;

        return (
          <ListItemButton
            key={variant}
            selected={selected}
            onClick={() => handleVariantSelect(variant)}
            data-testid={`menu-theme-variant-${variant}`}
          >
            <ListItemIcon>
              {variant === 'default' ? (
                <PaletteIcon htmlColor={theme.palette.text.primary} />
              ) : (
                <PaletteIcon
                  htmlColor={
                    variant === 'coral' ? theme.palette.primary.main : (theme.palette.success?.main ?? '#00897B')
                  }
                />
              )}
            </ListItemIcon>
            <ListItemText primary={formatMessage({ id: `navigation-menu.theme-variant.${variant}` })} />
            {selected ? <CheckIcon color="primary" fontSize="small" /> : null}
          </ListItemButton>
        );
      })}
    </>
  );
};
